import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {PurchaseFlowController} from "../../../flows/PurchaseFlowController";
import {iFrameState} from "../../../../services/IFrameState";
import {Money} from "../../../../../client/state/misc/Money";
import {authService} from "../../../../../client/connection/Services";
import {iFrameConnection} from "../../../../services/IFrameConnection";
import {IFrameMessages} from "../../../../../blink-sdk/messaging/IFrameMessages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {PanelActionButton} from "../../../panel-elements/ActionButton";
import {BASE_PANEL_WIDTH} from "../../../../../blink-sdk/Constants";


export class AutopayThresholdExceededPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = {
        width: "100%",
        textAlign: "center",
        opacity: 1,
        transition: "opacity ease-in .15s",
    };

    @styleRule
    text = {
        marginTop: 18,
        display: "block",
    };

    @styleRule
    updateLimit = {
        display: "inline-block",
        marginLeft: 8,
        cursor: "pointer",
        ...this.themeProps.PANEL_LINK,
    };
}

@registerStyle(AutopayThresholdExceededPanelStyle)
export class AutopayThresholdExceededPanel extends BasePanelPage {
    widthValue = BASE_PANEL_WIDTH;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            text: Messages.articleExceedsLimit,
            linkText: Messages.updateLimit,
        }
    }

    getButtonLabel() {
        const paymentDetails = PurchaseFlowController.getPaymentDetails();
        const currency = iFrameState.getPaymentDetailsCurrency();
        const articlePrice = new Money(paymentDetails.amount, currency);

        return Messages.readFor(articlePrice);
    }

    primaryButtonClick() {
        if (!authService.isAuthenticated()) {
            throw new Error("This panel shouldn't exist when user isn't authenticated!");
        }
        iFrameConnection.sendToIFrames(IFrameMessages.MANUAL_PAYMENT_REQUEST, {request: iFrameState.paymentDetails});
    }

    render() {
        return [
            <PanelActionButton label={this.getButtonLabel()} onClick={() => this.primaryButtonClick()}
                               testId="payWithBlinkBtn"/>,
            <div className={this.styleSheet.text}>
                <span>{this.options.text}</span>
                {this.getLink()}
            </div>
        ];
    }

    getLink() {
        // TODO @branch @Mihai - change articles to purchases
        return (
            <Link className={this.styleSheet.updateLimit} href={"/purchases/"} newTab>
                {this.options.linkText}
            </Link>
        );
    }
}
